// @flow
const snakeToTitleCase = (str: string): string =>
    str &&
    str
        .split('-')
        .map((s) => s[0].toUpperCase() + s.slice(1))
        .join('');

export default snakeToTitleCase;
